module.exports = __webpack_public_path__ + "static/img/top-bgimg.0ca44b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taoyuan/top-bgimg.png
// module id = 9jFV
// module chunks = 1